export const EVENT_EDIT_STORE_NAME = 'eventEdit';
export const EVENT_EDIT_ACTIONS_NAME = 'EVENT_EDIT';
export const EVENT_SETTING_EDIT_ACTIONS_NAME = 'EVENT_SETTINGS_EDIT';
